<div class="form autocomplete form--required">
  <label for="" class="label"> {{title}} </label>
  <h6 class="txt txt--paragraph">{{textInformation}}</h6>
  <input type="text" id="iexample" [attr.placeholder]="placeHolder" [formControl]="textInputValue"
    (ngModelChange)="onTextInputChange($event)" />
  <h6 class="form__info">{{hintText}}</h6>
  <div id="iexampleautocomplete-list" class="autocomplete-items corrected-backgroud-and-overflow"
    *ngIf="optionList.length > 0">
    <div [id]="option.id" (click)="onSelectValue($event)" *ngFor="let option of optionList">{{option.value}}<input
        type="hidden" [value]="option.id" /></div>
  </div>
</div>
<div *ngIf="selectedPersonData" class="form autocomplete ">
  <label for="disabled-person" [ngClass]="optional ? 'custom-label' : 'label'"> {{title}} </label>
  <input style="transform: translateY(3px);" name="disabled-person" id="disabled-person" type="text"
    [value]="selectedPersonData.fullName" readonly="readonly">
  <span class="back back--small u-mt10 global-hand" style="position: absolute;" (click)="onUnselect()">
    Buscar otra persona
  </span>
  <h6 class="txt txt--paragraph">&nbsp;</h6>
</div>


